import BrowserStorage from '@/scripts/helpers/browser-storage';
import loginController from '@/scripts/libs/login/controller';

const retrieveError = (jqXHR) => {
  if (jqXHR && jqXHR.responseJSON) return jqXHR.responseJSON.error;
};

const requester = {
  setupAjax() {
    const locale = I18n.currentLocale();
    if (BrowserStorage.getItem('access_token')) {
      $.ajaxSetup({
        headers: {
          'Authorization': 'Token token="' + BrowserStorage.getItem('access_token') + '"',
          'Accept-Language': locale,
        },
      });
    } else {
      $.ajaxSetup({
        headers: {
          'Accept-Language': locale,
        },
      });
    }
  },

  get(options, callback) {
    return new Promise((resolve, reject) => {
      requester.setupAjax();
      $.ajax({
        method: 'GET',
        url: options.url,
        data: options.params,
      })
        .done((res) => {
          if (typeof callback === 'function') callback(res);
          else {
            if (res == null) reject(new Error('empty response'));
            else resolve(res);
          }
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          const currentPath = window.location.pathname;

          // Unauthorized user should be kicked from any of these path
          const currentPathIsForbidden = [
            '/',
            '/likes',
            '/watch-later',
            '/profile',
          ].some(path => path === currentPath); // currentPath matches some of these path

          if (jqXHR.status === 401 && currentPathIsForbidden) {
            loginController.logout(location.origin);
          }

          if (typeof callback === 'function') callback(textStatus);
          else reject(new Error(retrieveError(jqXHR) || textStatus));
        })
      ;
    });
  },

  post(options, callback, skipSetup) {
    return new Promise((resolve, reject) => {
      if (!skipSetup) requester.setupAjax();

      const additionalOptions = { ...options };
      delete additionalOptions.params;
      delete additionalOptions.url;

      $.ajax({
        ...additionalOptions,
        method: 'POST',
        url: options.url,
        data: options.params,
      })
        .done((res) => {
          if (typeof callback === 'function') callback(res);
          else resolve(res);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          if (typeof callback === 'function') callback(jqXHR, errorThrown);
          else reject(new Error(retrieveError(jqXHR) || textStatus));
        })
      ;
    });
  },

  put(options, callback) {
    return new Promise((resolve, reject) => {
      requester.setupAjax();
      $.ajax({
        method: 'PUT',
        url: options.url,
        data: options.params,
      })
        .done((res) => {
          if (typeof callback === 'function') callback(res);
          else resolve(res);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          if (typeof callback === 'function') callback(jqXHR, errorThrown);
          else reject(new Error(retrieveError(jqXHR) || textStatus));
        })
      ;
    });
  },

  delete(options, callback) {
    return new Promise((resolve, reject) => {
      requester.setupAjax();
      $.ajax({
        method: 'DELETE',
        url: options.url,
      })
        .done((res) => {
          if (typeof callback === 'function') callback(res);
          else resolve(res);
        })
        .fail((jqXHR, textStatus, errorThrown) => {
          if (typeof callback === 'function') callback(jqXHR, errorThrown);
          else reject(new Error(retrieveError(jqXHR) || textStatus));
        })
      ;
    });
  },

  getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts
        .pop()
        .split(';')
        .shift()
      ;
    }
  },
};

export default requester;
